import { Grid, TextField, InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const AdminActions = ({ auxSearcher, setAuxSearcher }) => {
  return (
    <Grid container sx={{ mt: 3 }}>
      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          placeholder="Buscar por nombre, rut, email..."
          value={auxSearcher}
          onChange={(e) => setAuxSearcher(e.target.value)}
          size="small"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="action" />
              </InputAdornment>
            ),
          }}
          sx={{ marginTop: "0px !important" }}
        />
      </Grid>
    </Grid>
  );
};

export default AdminActions;
